module.exports = Globalize;


//////////////////
// WEBPACK FOOTER
// external "Globalize"
// module id = 59
// module chunks = 0